import { render, staticRenderFns } from "./CorporateInfo.vue?vue&type=template&id=565ea852&scoped=true"
import script from "./CorporateInfo.vue?vue&type=script&lang=js"
export * from "./CorporateInfo.vue?vue&type=script&lang=js"
import style0 from "./CorporateInfo.vue?vue&type=style&index=0&id=565ea852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ea852",
  null
  
)

export default component.exports